export const STREAM_TYPE = Object.freeze({ MAIN: 'MAIN', SUB: 'SUB' });
export const CAMERA_TYPE = Object.freeze({
    ID: 'ID',
    FACE: 'FACE',
    TRUCK_ID: 'TRUCK_ID',
    TRUCK_FACE: 'TRUCK_FACE',
    LP: 'LP',
    TRAILER: 'TRAILER',
    TRUCK: 'TRUCK',
    CAR_ID: 'CAR_ID',
    CAR_FACE: 'CAR_FACE',
    OVERVIEW: 'OVERVIEW',
    PTZ: 'PTZ',
    BOL: 'BOL',
    SCANNER: 'SCANNER',
});

export const CAMERA_ORDER = {
    PREVIEW: 0,
    VIDEO_WALL: 1,
    [CAMERA_TYPE.TRUCK_FACE]: 2,
    [CAMERA_TYPE.CAR_FACE]: 3,
    [CAMERA_TYPE.TRUCK_ID]: 4,
    [CAMERA_TYPE.CAR_ID]: 5,
    DEFAULT: 6,
};

const loggingEnabledDesks = ['DV03-04', 'DV03-08'];

const _defaultLogsEnabled = import.meta.env.VITE_ENV !== 'production';

let isDeskLoggingEnabled;
export function setIsDeskLoggingEnabled(desk) {
    const deskName = desk?.name || '';
    isDeskLoggingEnabled = loggingEnabledDesks.includes(deskName);
}

export function isCameraStreamLogsEnabled(mode) {
    const flag = window.enableStreamingLogs;
    if (flag === false) return false;
    const enableLog = flag === true || isDeskLoggingEnabled || mode === 'error';
    if (enableLog) return true;
    return _defaultLogsEnabled;
}
